import { AttacherFilter, isOccupied0dAttacher } from "@animech/supermodel";
import { AttacherSolverContext } from "./attacher-solver-context";
import { FamilyType } from "./attacher-attribute";

type CustomAttacherFilter = (
	...args: [
		...Parameters<AttacherFilter>,
		context: Readonly<AttacherSolverContext>,
	]
) => ReturnType<AttacherFilter>;

const check = {
	isNotOccupied0dAttacher: (instance) => !isOccupied0dAttacher(instance),
} as const satisfies Record<string, CustomAttacherFilter>;

const attacherFilterByFamily: Partial<
	Record<FamilyType, CustomAttacherFilter>
> = {} as const;

const defaultAttacherFilter: CustomAttacherFilter = (instance, _context) =>
	check.isNotOccupied0dAttacher(instance);

export function createAttacherFilter(
	context: AttacherSolverContext,
): AttacherFilter {
	const { attacherAttributeMap } = context;

	return (instance) => {
		const family = attacherAttributeMap.get("family", instance);

		return (attacherFilterByFamily[family] ?? defaultAttacherFilter)(
			instance,
			context,
		);
	};
}
